import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'theme'
})
export class ThemePipe implements PipeTransform {

  transform(theme: string, element: string, show: boolean = true): any {
    if (!element || !theme) {
      return '';
    }

    if (show === true) {
      return theme.toLowerCase() + '-theme-' + element;
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/pipe/theme.pipe.ts